import { css } from '@emotion/react'
import styled from '@emotion/styled/macro'

export const StyledIssueTitle = styled.div<{
  hasNoDescription?: boolean
  isReadOnly?: boolean
}>(
  ({ isReadOnly, hasNoDescription }) => css`
    font-size: 20px;

    ${isReadOnly &&
    css`
      padding: 2px 0;
    `}

    ${hasNoDescription &&
    isReadOnly &&
    css`
      margin-bottom: 8px;
    `}
  `
)
